<div class="row my-2">
  <div class="col-6">
    <app-card [titulo]="tituloEdital">
      <div text>
        <div class="d-flex flex-column">
          <bdg-info-label direction="horizontal" label="Tipo de edital" labelType="body-1" labelStyle="fontWeight: 700">
            {{ tipoResidencia }}
          </bdg-info-label>
          <bdg-info-label
            direction="horizontal"
            label="Tempo restante para inscrição"
            labelType="body-1"
            labelStyle="fontWeight: 700"
          >
            {{ tempoRestante }}
          </bdg-info-label>
        </div>
      </div>
      <div chips>
        <mat-chip-list>
          <bdg-tag>{{ descricaoSituacaoEdital }}</bdg-tag>
        </mat-chip-list>
      </div>
    </app-card>
  </div>
</div>
